import { useContext } from 'react';
import TableFilterContext from './TableFilterContext';

const useTableFilters = () => {
  const tableFilterContext = useContext(TableFilterContext);
  if (tableFilterContext === null) {
    throw new Error('TableFilterContextProvider is not wrapped around your component.');
  }

  return tableFilterContext;
};

export default useTableFilters;
